import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios';
import { userObj } from "../../../../helper/protectedRoutes";
import baseUrl from "../../../../helper/api";
import axios from "../../../../api/axios";

const initialState = {
  data: [],
  isLoading: null,
  status: null,
};

const token = userObj?.token;

export const getDrivers = createAsyncThunk(
  "order/getDrivers",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/Order/lms/drivers`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (err) {
      console.log(err.response);
      return rejectWithValue(err.response.data.title);
    }
  }
);

const getDriversSlice = createSlice({
  name: "getDrivers",
  initialState,
  reducers: {},
  extraReducers: {
    [getDrivers.pending]: (state, action) => {
      state.status = "pending";
      state.isLoading = true;
    },
    [getDrivers.fulfilled]: (state, action) => {
      state.status = "success";
      state.isLoading = false;
      state.data = action.payload;
      // localStorage.setItem('user', JSON.stringify(action.payload))
    },

    [getDrivers.rejected]: (state, action) => {
      state.status = "failed";
      state.isLoading = false;
    },
  },
});

export default getDriversSlice.reducer;
